import React, { useState, useEffect } from 'react';
import { DepartmentType, ExternalType, OfficeType, ShipType } from '../../constants';
import { useOffices, useDepartments, useShips, useExternals } from '../Firestore/Resources';

const withType = (v, type) =>
  Object.fromEntries(v.map((v) => ({ _type: type, ...v })).map((v) => [v.id, v]));

export const useAddressables = () => {
  const [offices] = useOffices();
  const [ships] = useShips();
  const [departments] = useDepartments();
  const [externals] = useExternals();
  const [addressables, setAddressables] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (offices && ships && departments && externals) {
      setAddressables({
        ...withType(ships, ShipType),
        ...withType(offices, OfficeType),
        ...withType(externals, ExternalType),
        ...withType(
          departments.map((department) => {
            const parent = [...ships, ...offices].find((v) => v.id === department.parent);
            return {
              ...department,
              name: [parent.name, department.name].filter((v) => v).join(' '),
            };
          }),
          DepartmentType,
        ),
      });
      setLoading(false);
    }
  }, [offices, ships, departments, externals]);

  return [addressables, loading];
};
